import { render, staticRenderFns } from "./Jiangshijieshao.vue?vue&type=template&id=3c2f5fae&scoped=true"
import script from "./Jiangshijieshao.vue?vue&type=script&lang=js"
export * from "./Jiangshijieshao.vue?vue&type=script&lang=js"
import style0 from "./Jiangshijieshao.vue?vue&type=style&index=0&id=3c2f5fae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2f5fae",
  null
  
)

export default component.exports